module.exports = __webpack_public_path__ + "static/img/guidelines.5a1c649d.jpg";